"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimerWithReload = useTimerWithReload;
/* eslint-disable consistent-return */
const react_1 = require("react");
function useTimerWithReload(timerValue) {
    const [timer, setTimer] = (0, react_1.useState)(timerValue);
    (0, react_1.useEffect)(() => {
        if (!timer)
            return;
        const intervalId = setInterval(() => {
            setTimer((prev) => prev - 1);
        }, 1000);
        return () => clearInterval(intervalId);
    }, [timer]);
    const handleReloadTimer = (0, react_1.useMemo)(() => () => {
        setTimer((prev) => prev + timerValue);
    }, [timerValue]);
    return { timer, handleReloadTimer };
}
//# sourceMappingURL=useTimerWithReload.js.map